<template xmlns="http://www.w3.org/1999/html">
    <td :class="[worklogsView ? 'user-td' : 'first-column']">
        {{userName}}
        <i v-if="removeOption" class="fa fa-times remove-icon" aria-hidden="true" @click="deleteUser(userId)"></i>
    </td>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'UserCell',
  props: ['userId', 'worklogsView', 'removeOption', 'projectId'],
  data: function () {
    return {
      confirmation_options: {
        okText: 'Delete',
        cancelText: 'Cancel',
        verification: 'delete'
      },
    };
  },
  computed: {
    userName() {
      return this.$store.state.JiraUsers.users[this.userId].displayName;
    }
  },
  methods: {
    ...mapActions('WorkloadPlans', ['DELETE_USERS_WORKLOADS_FROM_PROJECT']),
    deleteUser(id) {
      const vm = this;
      this.$dialog.confirm(`<p><b>Delete ${vm.userName}</b></p>`, { okText: 'Delete', cancelText: 'Cancel', verification: 'close', html: true })
        .then(() => {
          vm.DELETE_USERS_WORKLOADS_FROM_PROJECT({ userId: vm.userId, projectId: vm.projectId });
        })
        .catch(() => {

        });
    }
  },
  mounted() {
  },
};

</script>

<style scoped>
    .user-td{
        width: 200px;
        min-width: 200px;
        /*position: absolute;*/
        position: sticky;
        position: -webkit-sticky;
        left: 0;
        z-index: 1;
        background: white;
    }
    .first-column {
        position: sticky;
        position: -webkit-sticky;
        left: 0;
        z-index: 1;
        background: white;
    }
    .remove-icon:hover {
        cursor: pointer;
        color: #ee0044;
    }
</style>
